import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';

const Animation = ({ animationData, scale = 1 }) => {
  let container;
  useEffect(() => {
    if (container) {
      lottie.loadAnimation({
        container,
        animationData,
        autoplay: true,
        loop: true
      });
    }
  }, []);

  const style = {
    transform: `scale(${scale})`,
    width: '100%',
    height: '100%'
  };

  return (
    <div
      ref={(ref) => {
        container = ref;
      }}
      style={style}
    />
  );
};

Animation.propTypes = {
  animationData: PropTypes.object,
  scale: PropTypes.number
};

export default Animation;
